import { DecorativeBgComponent } from 'signup-components/types';
import { Step } from 'signup-constants/Step';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { Data } from 'signup-constants/signupData/Data';
import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { getCurrentStepNumbering } from '../../flow-management/stepNumberingSelectors';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getSignupDataValue, isSignupDataCompleted } from '../../store/signup-data/selectors';
import { Tracker } from '../../store/tracking/action-creators';
import { getStepConfig } from '../../views/getStepConfig';
import { ExperimentKeys } from '../ExperimentKeys';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
const ACQ143MappedLoadingKeys = new Map([[LoadingKey.SignupRequest, LoadingKey.ACQ143SignupRequest], [LoadingKey.LoginAfterSignup, LoadingKey.ACQ143PortalCreated]]);
export const getACQ143EndpointLoadingKey = (state, loadingKey) => {
  const parameter = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  if (parameter && loadingKey && ACQ143MappedLoadingKeys.has(loadingKey)) return ACQ143MappedLoadingKeys.get(loadingKey);
  return loadingKey;
};
export const getTotalSteps = state => {
  const {
    totalSteps
  } = getCurrentStepNumbering(state);
  const isCompanySizeStepDataCompleted = isSignupDataCompleted(state, Data.CompanySize);
  const isACQ0143Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  const isACQ0145Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0145, [ExperimentParameterGroup.Variant_A]);
  const hasSubmittedCompanySizeOne = getSignupDataValue(state, Data.CompanySize) === CompanySizeOption.One && isCompanySizeStepDataCompleted;
  let additionalTotalSteps = 0;
  if (isACQ0143Variant) {
    // there are 4 or 5 setup steps displayed after signup
    // for company size one, the invite step is not shown during setup
    additionalTotalSteps = hasSubmittedCompanySizeOne ? 4 : 5;
  }
  if (isACQ0145Variant) {
    additionalTotalSteps = 5;
  }
  return totalSteps + additionalTotalSteps;
};
export const getDecorativeBgComponent = ({
  currentStep,
  activeLoading,
  activeError
}) => {
  const stepConfig = getStepConfig(currentStep);
  if (activeLoading || activeError || !stepConfig) {
    return undefined;
  }
  if (stepConfig.shouldUseBgCirclesIfInAcq143) {
    return DecorativeBgComponent.Circles;
  }
  return;
};
export const setFlowForACQ143 = ({
  stepsToRemove = [],
  isPreVerificationExistingUserSession = false
}) => dispatch => {
  const {
    postExistingAccountSelection: acq143VariantAPostExistingAccountSelectionSteps
  } = getFlowSteps();
  const acq143VariantAPreVerificationSteps = [Step.LandingPage, Step.CodeVerification];
  const acq143VariantAPostAccountCreationSteps = [];
  const acq143VariantAPostVerificationSteps = [Step.Password, Step.Name, Step.UseCase, Step.Industry, Step.CompanySize, Step.UserSize, Step.ManagementLevel, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
  const acq143NextSteps = [...(isPreVerificationExistingUserSession ? [Step.ExistingUser] : []), ...(isPreVerification() ? acq143VariantAPreVerificationSteps : []), ...acq143VariantAPostVerificationSteps, ...acq143VariantAPostAccountCreationSteps];
  const acq143FlowSteps = {
    acq143NextSteps,
    acq143VariantAPreVerificationSteps,
    acq143VariantAPostVerificationSteps,
    acq143VariantAPostAccountCreationSteps,
    acq143VariantAPostExistingAccountSelectionSteps
  };
  if (stepsToRemove.length > 0) {
    // replicating the logic inside FlowStateManager.removeSteps(stepsToRemove)
    Object.keys(acq143FlowSteps).forEach(key => {
      acq143FlowSteps[key] = NextStepManager.removeSteps(...stepsToRemove)(acq143FlowSteps[key]);
    });
  }
  dispatch(setFlow(acq143FlowSteps.acq143NextSteps, acq143FlowSteps.acq143VariantAPreVerificationSteps, acq143FlowSteps.acq143VariantAPostVerificationSteps, acq143FlowSteps.acq143VariantAPostAccountCreationSteps, acq143FlowSteps.acq143VariantAPostExistingAccountSelectionSteps));
  return acq143NextSteps;
};
export const setupAuthForOAuthExistingUserACQ143 = (state, experimentKey, dispatch) => {
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-variant_a`));
  dispatch(setFlowForACQ143({
    isPreVerificationExistingUserSession: getIsAuthenticated(state) && isPreVerification()
  }));
};